export function ProgressBar({ value = 0, max = 100, tone = 'default' }: { value?: number; max?: number; tone?: 'default' | 'ember' }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div style={{ height: 10, borderRadius: 999, background: 'var(--progress-track)', overflow: 'hidden' }}>
      <div
        style={{
          width: `${pct}%`,
          height: '100%',
          background: tone === 'ember' ? 'var(--ember)' : 'var(--cta-default)',
          borderRadius: 999,
          transition: 'width 0.3s ease',
        }}
      />
    </div>
  );
}
